module.exports = __webpack_public_path__ + "static/img/icon_lianbaxz_moren.28c4f610.png";